export const environments = {
  apiOpsBaseUrl: process.env.apiOpsBaseUrl,
  apiIamBaseUrl: process.env.apiIamBaseUrl,
  apiOrderBaseUrl: process.env.apiOrderBaseUrl,
  apiPaymentBaseUrl: process.env.apiPaymentBaseUrl,
  webAdminUrl: process.env.webadminUrl,
} as const;
